import { KeyActionEnum } from '@/types/enums'

export class KeyAction {
  public constructor (
    readonly kind: KeyActionEnum,
    readonly handler: Function,
    readonly resolver: Function | null,
    public event: any | null = null
  ) {}

  handle (): any {
    this.handler(this)
  }

  resolve (): boolean {
    if(this.resolver) {
      return this.resolver(this)
    } else {
      return true
    }
  }
}
